import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import PackageTable from './table/js/packageTable';
import PackageCreate from './create/js/packageCreate';

export default function PackageManagement() {
  const [reloadKey, setReloadKey] = useState(0);
  const [showCreateModal, setShowCreateModal] = useState(false);

  return (
    <div>
      <PackageTable
        reloadKey={reloadKey}
        onCreatePackage={() => setShowCreateModal(true)}
      />

      {showCreateModal && createPortal(
        <div className="eduss-global-modal-overlay" onClick={() => setShowCreateModal(false)}>
          <div className="eduss-global-modal large eduss-admin-form-modal" onClick={e => e.stopPropagation()}>
            <div className="eduss-global-modal-header">
              <h3>Create New Package</h3>
              <button onClick={() => setShowCreateModal(false)}>&times;</button>
            </div>
            <div className="eduss-global-modal-content">
              <PackageCreate
                onClose={() => setShowCreateModal(false)}
                onSubmit={() => { setReloadKey(k => k + 1); setShowCreateModal(false); }}
              />
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
}
